module.exports = __webpack_public_path__ + "static/header-896eed3cd57705dfea32bbb7494e62eb.mp4";